<template>
  <div class="container mx-auto">
    <Cards></Cards>
  </div>
</template>

<script>
import Cards from "./Cards";

export default {
  name: "Home",
  components: {
    Cards
  }
};
</script>

<style></style>
